<template>
  <div>
    <div class="content" style="width:auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{ typeName }}</span>
      </div>
      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width:88%;display: flex">
            <div class="start-label" />
            <span class="text">保养模板信息</span>
          </div>
          <el-row>
            <el-col :span="6">
              <el-form-item label="保养模板编号" prop="no">
                <el-input disabled v-model="form.no" placeholder="系统自动生成保养模板编号" style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="保养模板名称" prop="name">
                <el-input :disabled="!editMode" v-model="form.name" placeholder="请填写保养模板名称" style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="保养等级" prop="maintainLevelId">
                <el-select :disabled="!editMode" v-model="form.maintainLevelId" style="width: 90%" placeholder="系统自动带出申请科室">
                  <el-option v-for="item in maintainLevel" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建人" prop="createdUserName">
                <el-input v-model="form.createdUserName" disabled style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建日期" prop="createdTime">
                <el-date-picker disabled v-model="form.createdTime" style="width: 90%" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="系统默认为当前时间">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="保养说明" prop="desc">
                <el-input :disabled="!editMode" v-model="form.desc" placeholder="请填写保养说明" resize="none" type="textarea" :rows="5" style="width:95%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="备注" prop="remark">
                <el-input :disabled="!editMode" v-model="form.remark" placeholder="请填写备注" resize="none" type="textarea" :rows="5" style="width:95%"></el-input>
              </el-form-item>
            </el-col>
            <el-col style="display: flex;">
              <UploadFileList btnShowType="always" :editMode="editMode" :fileList="form.fileInfos" @fileChange="fileChange"></UploadFileList>
            </el-col>
          </el-row>
          <el-row style="height:30px"></el-row>
        </div>
        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>
    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="$router.go(-1)">返 回</el-button>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import GetDataMixin from "@/mixin/getData-mixin.js";
import {
  GetMaintainModuleById,
  SaveMaintainModule,
  RejectMaintainModule,
  GetMaintainLevels,
} from "@/api";
import { WarehouseOutStockOptions } from "@/enum";
import SelectTable from "@/components/select-table";
import ApproveInfo from "@/components/approve-info";
import ElImageViewer from "@/components/elImageViewer";
import UploadFileList from "@/components/upload-file-list";
export default {
  mixins: [GetDataMixin],
  components: {
    SelectTable,
    ApproveInfo,
    ElImageViewer,
    UploadFileList,
  },
  /** 定义属性 */
  data () {
    return {
      typeName: "保养模板",
      form: {},
      WarehouseOutStockOptions: WarehouseOutStockOptions,
      rules: {
        name: [
          { required: true, message: "保养模板名称不能为空", trigger: "blur" },
        ],
        maintainLevelId: [
          { required: true, message: "保养等级不能为空", trigger: "blur" },
        ],
      },
      editMode: false,
      showWorkFlowInfo: false,
      assetList: [],
      reject: RejectMaintainModule,
      maintainLevel: [],
      fileListOpen: true,
      fileList: [],
      dialogVisible: false,
      dialogImageUrl: "",
      fileName: "",
      fileId: 0,
    };
  },
  /** 计算属性，会监听依赖属性值随之变化 */
  computed: {},
  /** 监控data中的数据变化 */
  watch: {},
  /** 方法集合 */
  methods: {
    InitData () {
      var query = this.$route.query;
      if (query.id) {
        this.handleUpdate(query.id);
      } else {
        this.handleAdd();
      }
    },
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate (id) {
      GetMaintainModuleById({ id }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;
        this.initWorkFlowProperty(this.form);
      });
    },
    /**
     * 初始化表单
     */
    resetForm () {
      this.form = {
        userId: this.userInfo.id,
        createdUserName: this.userInfo.name,
        createdTime: this.parseTime(new Date(), "{y}-{m}-{d}"),
        name: null,
        maintainLevelId: null,
        desc: null,
        remark: null,
        fileInfos: [],
        orgCode :sessionStorage.getItem('orgId')
      };
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        SaveMaintainModule(this.form).then((res) => {
          this.$my_message(`执行成功`, "success");
          sessionStorage.setItem("editMode", 0);
          this.$router.push({ path: this.getMainPath(this.$route.path) });
        }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
      });
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   this.$router.go(-1);
      // });
      this.$router.push({ path: this.getMainPath(this.$route.path) });
    },
    getMaintainLevels () {
      let query = { ...this.defaultAllQueryParams };
      GetMaintainLevels(query).then((res) => {
        this.maintainLevel = res.returnData.data;
      });
    },
    privewImg (file) {
      // this.dialogImageUrl = file.path;
      // this.dialogVisible = true;
      this.dialogVisible = true;
      this.fileId = file.id;
      this.fileName = file.name;
    },
    closeImageViewer () {
      this.dialogVisible = false;
    },
    RemoveFile (file) {
      var index = this.form.fileInfos.indexOf(file);
      if (index > -1) {
        this.form.fileInfos.splice(index, 1);
      }
    },
    fileValidate (file) {
      // if (file.size > 1024 * 1024 * 3) {
      //   this.$my_message(`图片大小超过3M,上传失败！`, "warning");
      //   return false;
      // }
      if (this.form.fileInfos.length == 5) {
        this.$my_message(
          `抱歉！当前上传附件总数已超过系统限制，请核实后再上传！`,
          "warning"
        );
        return false;
      }
      let size = 0;
      this.form.fileInfos.forEach((item) => {
        size += item.size;
      });
      if (size + file.size >= 15 * 1024 * 1024) {
        this.$my_message(
          `抱歉！当前上传附件总大小已超过系统限制，请核实后再上传！`,
          "warning"
        );
        return false;
      }
    },
    onUploadSuccess (response, file, fileList) {
      response.returnData.forEach((item) => {
        this.form.fileInfos.push(item);
      });
    },
    fileChange (e) {
      this.form.fileInfos = e;
    },
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () {
    this.InitData();
  },
  /** 生命周期 - 挂载完成（可以访问DOM元素） */
  mounted () {
    this.getWarehouses();
    this.getMaintainLevels();
  },
  /** 生命周期 - 创建之前 */
  beforeCreate () { },
  /** 生命周期 - 挂载之前 */
  beforeMount () { },
  /** 生命周期 - 更新之前 */
  beforeUpdate () { },
  /** 生命周期 - 更新之后 */
  updated () { },
  /** 生命周期 - 销毁之前 */
  beforeDestroy () { },
  /** 生命周期 - 销毁完成 */
  destroyed () { },
  /** 如果页面有keep-alive缓存功能，这个函数会触发 */
  activated () { },
};
</script>

<style lang="scss" scoped>
</style>
